import { MatrixFieldInfoEntity } from "./matrix-field-info.entity";

export class MatrixDefInfoEntity {
  id: string;
  code: string;
  name: string;
  conditionField: MatrixFieldInfoEntity[];
  dataField: MatrixFieldInfoEntity[];
}
